module.exports = __webpack_public_path__ + "static/media/ls-mark-wordmark.a02390ec.svg";